import { render } from "./LHCourseTerms.vue?vue&type=template&id=32bde53f"
import script from "./LHCourseTerms.vue?vue&type=script&lang=js"
export * from "./LHCourseTerms.vue?vue&type=script&lang=js"

import "./LHCourseTerms.vue?vue&type=style&index=0&id=32bde53f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__